// packages block
import React, { useRef, useState } from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {
  Popper,
  Paper,
  Grow,
  ClickAwayListener,
  MenuItem,
  MenuList,
  Avatar,
} from "@material-ui/core";
// common block
import { DetailTabs } from "./detailTabs";
import { Loader } from "../../../../components/loader";
import { BackButton } from "../../../../components/backButton";
import { useStyles } from "../../../../components/managementTable/styles";
// constants, theme, utils and api block
import { PrimaryBackgroundColor } from "../../../../styles/colors";
import { formatEmptyToNA } from "../../../../util/stringManipulation";
import { useSelector } from "react-redux";

export const StudentDetail = ({ student, editStudent }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const { role } = useSelector((state) => state.user);

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  if (!student)
    return (
      <div className="invoice-student-container">
        <Loader />
      </div>
    );
  else
    return (
      <div className="invoice-student-container">
        <div style={{ padding: 20 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <BackButton />
            </div>

            <div style={{ color: "black", fontWeight: "bold", flex: 1 }}></div>

            {(role === "manager" || role === "superadmin") && (
              <div
                ref={anchorRef}
                aria-controls={open ? "menu-list-grow" : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                role="presentation"
                // onClick={(e) => {
                //   openActionMenu(e);
                // }}
                className={classes.actionButton}
              >
                <MoreHorizIcon style={{ color: "black" }} />
              </div>
            )}

            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                          onClick={() => editStudent()}
                        >
                          Edit Student
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar
              style={{
                height: 100,
                width: 100,
                marginRight: "20px",
                backgroundColor: PrimaryBackgroundColor,
              }}
            >
              {student?.file !== null ? (
                <img
                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                  src={`${student?.file}`}
                />
              ) : (
                <Avatar
                  style={{
                    height: 100,
                    width: 100,
                    backgroundColor: PrimaryBackgroundColor,
                  }}
                />
              )}
            </Avatar>

            <div style={{ padding: "0px 20px" }}>
              <div
                style={{
                  color: PrimaryBackgroundColor,
                  fontWeight: "700",
                  textTransform: "capitalize",
                }}
              >
                {student?.firstName} {student?.lastName}
              </div>

              <div style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
                Student ID: {formatEmptyToNA(student?.studentRegNo)}
              </div>

              <div style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
                Grade: {formatEmptyToNA(student?.grade)}
              </div>
            </div>
          </div>
        </div>

        <DetailTabs student={student} />
      </div>
    );
};
